export enum AppEnvironment {
    Development = 'Develop',
    AutoDevelop = 'Development',
    Production = 'Production',
    Performance = 'Performance',
    Stage = 'Staging',
    Pr = 'pr',
    Feature7 = 'feature7',
    MEDDev = 'med.dev',
    MEDProd = 'med.prod',
}
